module.exports = __webpack_public_path__ + "static/media/Home_204387825.26680023.jpg";